import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckIcon } from './icons/CheckIcon';
import { ProfileOutlined } from '@ant-design/icons';
import { SectionIcon } from './SectionIcon';

export const DocInfo = ({ docinfo }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="docinfo" className="card" aria-labelledby="docinfo-title" style={{ gap: 20 }}>
            <h2 id="docinfo-title" className="h2">
                <SectionIcon icon={ProfileOutlined} />
                {t('docinfo.title')}
            </h2>
            <dl className="dl">
                {docinfo.fields.map(field => (
                    <div key={field.label}>
                        <dt className="dt">{field.label}</dt>
                        <dd className={`dd${field.mono ? ' mono' : ''}`}>
                            {field.value}
                            {field.sub && <span className="sub">{field.sub}</span>}
                        </dd>
                    </div>
                ))}
                {docinfo.files.length > 0 && (
                    <div>
                        <dt className="dt">{t('docinfo.filesUsed')}</dt>
                        <dd className="dd filelist">
                            {docinfo.files.map(name => (
                                <span className="fileok" key={name}>
                                    <CheckIcon />
                                    {name}
                                </span>
                            ))}
                        </dd>
                    </div>
                )}
            </dl>
        </section>
    );
};
